import { render, staticRenderFns } from "./UserWilayah.vue?vue&type=template&id=7810c773"
import script from "./UserWilayah.vue?vue&type=script&lang=js"
export * from "./UserWilayah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports